import { resolveLocale } from './dateUtils';

export const decimalSeparatorForLanguage = (language = 'pt-BR') => (
  resolveLocale(language) === 'en-US' ? '.' : ','
);

export const formatMoneyNumber = (value, options = {}) =>
  Number(value || 0).toLocaleString(resolveLocale(options.language), {
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  });

export const formatDecimalValue = (value, language = 'pt-BR', options = {}) => {
  if (value === '' || value === null || value === undefined) return '';
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '';
  return numericValue.toLocaleString(resolveLocale(language), {
    useGrouping: false,
    minimumFractionDigits: options.minimumFractionDigits ?? 0,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  });
};

export const formatDecimalInput = (value = '', language = 'pt-BR') => {
  const raw = String(value).replace(/[^\d,.]/g, '');
  const lastSeparator = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
  if (lastSeparator < 0) return raw.replace(/\D/g, '');
  const integer = raw.slice(0, lastSeparator).replace(/\D/g, '');
  const decimal = raw.slice(lastSeparator + 1).replace(/\D/g, '').slice(0, 2);
  return `${integer || '0'}${decimalSeparatorForLanguage(language)}${decimal}`;
};

export const parseDecimalInput = (value = '') => {
  const raw = String(value).trim().replace(/[^\d,.-]/g, '');
  if (!raw) return Number.NaN;
  const negative = raw.startsWith('-');
  const unsigned = raw.replace(/-/g, '');
  const lastSeparator = Math.max(unsigned.lastIndexOf(','), unsigned.lastIndexOf('.'));
  const integer = (lastSeparator < 0 ? unsigned : unsigned.slice(0, lastSeparator)).replace(/\D/g, '') || '0';
  const decimal = lastSeparator < 0 ? '' : unsigned.slice(lastSeparator + 1).replace(/\D/g, '');
  const normalized = `${negative ? '-' : ''}${integer}${decimal ? `.${decimal}` : ''}`;
  return Number(normalized);
};
